

export default function getPrivateResourceSettings(
collaborators) {
  const privateSettings = collaborators.
  filter(({ isPrivate }) => isPrivate);

  return privateSettings && privateSettings.length ?
  privateSettings[0] :
  { isPrivate: false };
}